(() => {
  async function init() {
    for (const grid of document.querySelectorAll('[data-home-game-directory]')) {
      if (grid.dataset.bound) continue;
      grid.dataset.bound = 'true';
      try {
        const response = await fetch(grid.dataset.homeUrl, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Catalog unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const catalog = page.querySelector('[data-pb-catalog] > .pb-compact-games');
        if (!catalog) throw new Error('Catalog unavailable');
        const tiles = Array.from(catalog.querySelectorAll(':scope > .pb-preview-game-tile'), tile => {
          const clone = tile.cloneNode(true);
          clone.hidden = false;
          clone.removeAttribute('data-shopify-editor-block');
          clone.removeAttribute('id');
          return clone;
        });
        grid.replaceChildren(...tiles);
        if (!tiles.length) grid.textContent = 'No games have been added yet.';
      } catch {
        const link = document.createElement('a');
        link.href = grid.dataset.homeUrl + '#x-games';
        link.textContent = 'Browse our games on the homepage';
        grid.replaceChildren(link);
        delete grid.dataset.bound;
      }
    }
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
